import React, { createContext } from 'react';
import { HashRouter, Routes, Route } from 'react-router-dom';
import Home from './pages/Home';
import Projects from './pages/Projects';
import Discussions from './pages/Discussions';
import Passport from './pages/Passport';
import ProjectViewer from './pages/ProjectViewer';
import NavigationBar from './components/NavigationBar';
import AnalyticsListener from './components/AnalyticsListener';

export const ThemeContext = createContext(null);

export default function Router() {
    return (
        <ThemeContext.Provider value={''}>
            <HashRouter>
                <AnalyticsListener />
                <NavigationBar />
                <Routes>
                    <Route index element={<Home />} />
                    <Route path='/home/' element={<Home />} />
                    <Route path='/projects/' element={<Projects />} />
                    <Route path='/ask-me-anything/' element={<Discussions />} />
                    <Route path='/passport/' element={<Passport />} />
                    <Route path='/guestbook/' element={<Passport />} />
                    <Route path='/project/:repo' element={<ProjectViewer />} />
                </Routes>
            </HashRouter>
        </ThemeContext.Provider>
    );
}
